export default {
  idc_rectification: false,
  rectification_type: null,
  idc_rectification_symmetrical: false,
  rectification_abduction1: null,
  rectification_abduction2: null,
  idc_adjustable_adb: false,
  idc_growth_system: false,
  idc_catch_up_wedge: false,
  pedometer_module: "SEPARATED",
  pedometer_module_a: null,
  pedometer_module_b: null,
  pedometer_module_c: null,
  idc_thick_foam: false,
  rigid_foam: null,
  plastazote: null,
  transfer_id: null,
  evazote: null,
  a: null,
  b: null,
  c: null,
  d: null,
  e: null,
  f: null,
  g: null,
  h: null,
  i: null,
  j: null,
  k: null,
  l: null,
  m: null,
  n: null,
  o1: null,
  o2: null,
  p1: null,
  p2: null,
  q1: null,
  q2: null,
  r1: null,
  r2: null,
  s1: null,
  s2: null,
  t1: null,
  t2: null,
  u1: null,
  u2: null,
  v1: null,
  v2: null,
  headrest_module: {
    idc_headrest: false,
    renew: null,
    type: null,
    headrest_type: null,
    albatros_size: null,
    mounting_type: null,
    idc_thierry: false,
    vital_scrolling: null,
    finishing: null,
    mounting: null,
    a: null,
    b: null,
    c: null
  },
  tablet_module: {
    idc_tablet: true,
    type: null,
    idc_standard: false,
    matter: null,
    tablet_type: null,
    comeback: null,
    a: null,
    b: null,
    c: null,
    d: null,
    e: null,
    f: null
  },
  shoulder_pad_position: null,
  shoulder_pad_size_trap: null,
  shoulder_pad_strap_matter: null,
  shoulder_pad_velcro: null,
  shoulder_pad_clip: null,
  shoulder_pad_cushion: null,
  shoulder_pad_workshop: null,
  thorax_position: null,
  thorax_size_trap: null,
  thorax_strap_matter: null,
  thorax_velcro: null,
  thorax_clip: null,
  thorax_cushion: null,
  thorax_workshop: null,
  chest_position: null,
  chest_size_trap: null,
  chest_strap_matter: null,
  chest_velcro: null,
  chest_clip: null,
  chest_cushion: null,
  chest_workshop: null,
  pelvis_position: null,
  pelvis_size_trap: null,
  pelvis_strap_matter: null,
  pelvis_velcro: null,
  pelvis_clip: null,
  pelvis_cushion: null,
  pelvis_workshop: null,
  femoral_position: null,
  femoral_size_trap: null,
  femoral_strap_matter: null,
  femoral_velcro: null,
  femoral_clip: null,
  femoral_cushion: null,
  femoral_workshop: null,
  tibial_position: null,
  tibial_size_trap: null,
  tibial_strap_matter: null,
  tibial_velcro: null,
  tibial_clip: null,
  tibial_cushion: null,
  tibial_workshop: null,
  foot_position: null,
  foot_size_trap: null,
  foot_strap_matter: null,
  foot_velcro: null,
  foot_clip: null,
  foot_cushion: null,
  foot_workshop: null,
  wrist_position: null,
  wrist_size_trap: null,
  wrist_strap_matter: null,
  wrist_velcro: null,
  wrist_clip: null,
  wrist_cushion: null,
  wrist_workshop: null,
  breastplate_module: {
    idc_breastplate: true,
    breastplate: null,
    breastplate_type: null,
    size: null,
    a: null,
    b: null,
    c: null,
    d: null,
    e: null,
    construction_type: null,
    idc_shoulder_socket: false,
    idc_adjustment_cebelor: false
  },
  breastplate_comment: null,
  idc_bracket: false,
  bracket_renew: null,
  bracket: null,
  bracket_position: null,
  other: null,
  serial_number: null,
  bracket_color_id: null,
  bracket_comments: null,
  plastazote_color_id: null,
  thermozaic_color_id: null,
  cover_color_id: null,
  cover2_color_id: null,
  three_d_color_id: null,
  other_finishing: null,
  articles: []
};
